export default "__VITE_ASSET__KeTGtlJ___"